export const DataType = {
  string: "string",
  decimal: "decimal",
  integer: "integer",
  boolean: "boolean",
  date: "date",
  datetime: "datetime",
  email: "email",
};

export const DataTypeKeys = Object.keys(DataType);
